import { URL_QUERY_STRING } from "./storage-keys";

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setItem = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

export const removeItem = (key: string): void => {
  localStorage.removeItem(key);
};

export const getSiteCode = () => {
  const currentSiteCode = new URLSearchParams(window.location.search).get('site-code');
  if (currentSiteCode) {
    return currentSiteCode;
  }
  const query = getItem(URL_QUERY_STRING);
  const url = new URLSearchParams(query ? query : '');
  const queryObject = Object.fromEntries(url);
  const siteCode = queryObject['site-code'] || 'jp-profile';
  return siteCode;
};

export const getCountry = () => {
  const query = getItem(URL_QUERY_STRING);
  const url = new URLSearchParams(query ? query : '');
  const queryObject = Object.fromEntries(url);
  const country = queryObject['country'] || 'JP';
  return country;
};